import React from "react";
import styled from "styled-components";

const GalleryDescription = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 10%;
  box-sizing: border-box;
  transition: all .3s;
  h2 {
    font-size: 35px;
    line-height: 45px;
    z-index: 2;
  }
  &:after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(to bottom, rgba(0,0,0,.2) 0%,rgba(0,0,0,0.65) 50%,rgba(0,0,0,.2) 100%);
    z-index: 1;
    opacity: .7;
    transition: all .3s;
  }
  &:hover {
    &:after {
      background: linear-gradient(to bottom, rgba(0,0,0,.3) 0%,rgba(0,0,0,0.75) 50%,rgba(0,0,0,.3) 100%);
      opacity: 1;
    }
  }
`;

export default GalleryDescription;



// WEBPACK FOOTER //
// ./src/styled-components/GalleryDescription.js